import { AxiosInstance } from 'axios'
import { axiosProxy } from '@/plugins/axios'
import { Artist } from './Artist'
import { ArtistTransformer } from './ArtistTransformer'
import { Artwork } from '../artwork/Artwork'
import { ProfileArtworkTransformer } from '../artwork/ProfileArtworkTransformer'
import { PaginationTransformer } from '../pagination/PaginationTransformer'

export class ArtistRepository {
  private api: AxiosInstance = axiosProxy

  async getArtist (slug: string): Promise<Artist> {
    try {
      const res = await this.api.get(`artists/${slug}?include=media,posts`)
      if (res.data['data']) {
        return new ArtistTransformer().toClass(res.data['data'])
      }
      throw Error('Data not represent on response.')
    } catch (error) {
      throw error
    }
  }

  async getCV (id: string) {
    try {
      const res = await this.api.get(`artists/${id}/cv`)
      return res.data['data']
    } catch (error) {
      throw error
    }
  }

  async subscribe (user: { id: string|number }, artist: { id: string|number }) {
    return (await this.api.post(`artists/${artist.id}/subscriptions`))['data']['data']
  }



  // Returns users subscriptions
  async profileSubscriptions (page: number = 1) {
    const res = await this.api.get(`profile/subscriptions?page=${page}`)
    return {
      data: res.data['data'].map((artwork: Artwork) => new ArtistTransformer().toClass(artwork)),
      pagination: new PaginationTransformer().toClass(res.data['meta'])
    }
  }

}


export const theArtistRepository = new ArtistRepository()
